'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.ConditionalSpinner = void 0;

var _extends2 = require('babel-runtime/helpers/extends'),
    _extends3 = _interopRequireDefault(_extends2),
    _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties'),
    _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _officeUiFabricReact = require('office-ui-fabric-react'),
    _ShowHide = require('../ShowHide'),
    _ShowHide2 = _interopRequireDefault(_ShowHide);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}
/**
Conditionally render a spinner with other props.
For a list of all props visit [Spinner Docs](https://developer.microsoft.com/en-us/fluentui#/controls/web/spinner)
*/


var ConditionalSpinner = function ConditionalSpinner(a) {
  var b = a.show,
      c = a.label,
      d = a.labelPosition,
      e = (0, _objectWithoutProperties3.default)(a, ['show', 'label', 'labelPosition']);
  return _react2.default.createElement(_ShowHide2.default, {
    show: b
  }, _react2.default.createElement(_officeUiFabricReact.Spinner, (0, _extends3.default)({
    label: c,
    ariaLive: 'assertive',
    labelPosition: d
  }, e)));
};

exports.ConditionalSpinner = ConditionalSpinner, ConditionalSpinner.propTypes = {
  show: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  labelPosition: _propTypes2.default.string
}, ConditionalSpinner.defaultProps = {
  show: !1,
  label: '',
  labelPosition: 'right'
}, exports.default = _react2.default.memo(ConditionalSpinner);